import {AbstractModel} from './abstract-model';
import {Product} from './product';
import {Currency} from './currency';
import {OfferGoal} from './offer-goal';
import {Country} from './country';
import {OfferGoalType} from './offer-goal-type';

export class Offer extends AbstractModel {
  id: number | null = null;
  name: string | null = null;
  product: Product | null = null;
  conversionType: string | null = null;
  descriptionHtml: string | null = null;
  descriptionText: string | null = null;
  previewUrl: string | null = null;
  defaultUrl: string | null = null;
  currency: Currency | null = null;
  countries: string[] = [];
  verticals: number[] | null = null;
  private: boolean | null = null;
  requireApproval: boolean | null = null;
  enabled: boolean | null = null;
  offerGoals: OfferGoal[] = [];
  payout: number = 0;

  override deserialize(input: any): this {
    super.deserialize(input);

    this.countries?.sort();

    if (input.product) {
      this.product = new Product().deserialize(input.product);
    }

    if (input.currency) {
      this.currency = new Currency().deserialize(input.currency);
    }

    if (input.offerGoals) {
      this.offerGoals = input.offerGoals.map((offerGoal: any) => new OfferGoal().deserialize(offerGoal));
    }

    return this;
  }

  getRegistrationPayout(): number | null {
    if (!this.offerGoals.length) {
      return null;
    }

    let offerGoal = this.offerGoals.find((offerGoal: OfferGoal) => offerGoal.goal?.identifier === 'registration');
    if (!offerGoal || !offerGoal.types.length) {
      offerGoal = this.offerGoals.find((offerGoal: OfferGoal) => offerGoal.goal?.identifier === 'validation');

      if (!offerGoal || !offerGoal.types.length) {
        return null;
      }
    }

    const offerGoalType = offerGoal.types.find((type: OfferGoalType) => type.goalType?.identifier === 'p1');

    return offerGoalType?.payoutAmount ?? null;
  }

  getCountryEmoji(country: string): string {
    return Country.getFlagEmoji(country);
  }

  getGeoList(): string {
    if (!this.countries?.length) {
      return '';
    }

    return this.countries.map((country: string) => Country.getFlagEmoji(country)).join(' ');
  }

  override toString(): string {
    return this.name ?? '';
  }
}
